import { render, staticRenderFns } from "./viewRosterPropertyGroup.vue?vue&type=template&id=456e2184&"
import script from "./viewRosterPropertyGroup.vue?vue&type=script&lang=js&"
export * from "./viewRosterPropertyGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VForm,VRow,VSheet,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('456e2184')) {
      api.createRecord('456e2184', component.options)
    } else {
      api.reload('456e2184', component.options)
    }
    module.hot.accept("./viewRosterPropertyGroup.vue?vue&type=template&id=456e2184&", function () {
      api.rerender('456e2184', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Roster/RosterPropertyGroup/viewRosterPropertyGroup.vue"
export default component.exports